
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 1043.4 990.8"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M777.4 520.1h-88.8l-3.1 5.8h-22l105-200.3h-12.1l23.1-44.1h-607L35 543.9h82.1L94 588h559l-3.1 5.9h88.8l3.1-5.9h64.9v-62.1h-32.4z"}}),_c('circle',{attrs:{"transform":"rotate(-45.001 161.537 668.838)","cx":"161.5","cy":"668.8","r":"58.8"}}),_c('circle',{attrs:{"transform":"rotate(-45.001 297.253 668.84)","cx":"297.3","cy":"668.8","r":"58.8"}}),_c('circle',{attrs:{"transform":"rotate(-45.001 432.968 668.84)","cx":"433","cy":"668.8","r":"58.8"}}),_c('circle',{attrs:{"cx":"729.3","cy":"668.8","r":"58.8"}}),_c('circle',{attrs:{"cx":"910.7","cy":"668.8","r":"58.8"}}),_c('path',{attrs:{"d":"M993.4 302.5h-128v87.1l138.3 50zM796 394.6V486.7l39.6 15.2V588h147.2c13.5 0 24.4-12.2 24.4-27.3v-37.2l1.2-54.5L796 394.6z"}})])
          )
        }
      }
    